<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">온마음 관리자 로그인</h4>
                  <p class="mb-0">아이디와 비밀번호를 입력해주세요</p>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <input type="text" placeholder="아이디" class="form-control form-control-lg" v-model="userId"/>
                  </div>
                  <div class="mb-3">
                    <input type="password" placeholder="비밀번호" class="form-control form-control-lg" v-model="userPw" @keypress="pressEnter($event)"/>
                  </div>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="saveId" v-model="isSaveId">
                    <label class="form-check-label" for="saveId">아이디 기억하기</label>
                  </div>
                  <div class="text-center">
                    <button class="btn btn-lg w-100 btn-gradient-onmaum mb-0 mt-4" @click="login()">로그인</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div class="position-relative h-100 m-3 px-7 border-radius-lg d-flex flex-column overflow-hidden justify-content-center">
                <span class="mask bg-onmaum opacity-4"></span>
                <h3 class="mt-5 text-secondary font-weight-bolder position-relative" >"늘 <span style="color: #FF931E;">On</span> 되어있습니다"</h3>
                <p class="text-secondary position-relative mb-5">고객 중심적인 사고와 합리적인 상품,<br/>지속적 관리로 서로 상생합니다.</p>
                <img :src="logo" style="width: 40%; margin-left: auto; margin-right: auto;"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
const body = document.getElementsByTagName("body")[0];
import logo from '@/assets/img/logo_new.svg'

export default {
  name: "signinVue",
  components: {
  },
  data() {
    return {
      userId: this.$cookies.isKey('isSaveId')?this.$cookies.get('isSaveId'):'',
      userPw: '',
      isSaveId: this.$cookies.isKey('isSaveId')?true:false,
      logo,
    }
  },
  methods:{
    login(){
      if(this.isSaveId){
        this.$cookies.set('isSaveId', this.userId, '365d');
      }else{
        this.$cookies.remove('isSaveId');
      }
      this.$store.dispatch('login', {'id': this.userId, 'pw': this.userPw});
    },

    pressEnter(e){
      if(e.keyCode == 13){
        this.login();
      }
    },
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
